/**
 * Converts a string to a number. The string can be formatted
 * with a comma or a dot as a decimal separator.
 * @param value The string to convert to a number.
 */
export function getAmountAsNumber(value: string | undefined) {
  if (!value) return 0;
  const normalized =
    value.indexOf(".") === -1 && value.indexOf(",") > -1
      ? value.replace(",", ".")
      : value;
  const returnValue = parseFloat(normalized);
  return !isNaN(returnValue) ? returnValue : 0;
}
